var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7577b5c7e0d36ea2414efae7533045714ccaf890"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["brands-app@get-it-done-tech-gmbh"]={id:"7577b5c7e0d36ea2414efae7533045714ccaf890"};
      